module.exports = __webpack_public_path__ + "static/packlims-5456f1b5b1624827d671fca5d3c06fd0.png";